import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../../__styling'

export const SidebarFilterContainer = styled('div')<{
    topMarginOverride?: number
}>(({ topMarginOverride }) => ({
    display: 'flex',
    gap: calcRem(24),
    flexDirection: 'column',
    marginTop: topMarginOverride,

    [breakpoint('lg')]: {
        gap: calcRem(32),
    },
}))

export const SidebarInputContainer = styled('div')(({ theme }) => ({
    gap: calcRem(8),
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
}))

export const SidebarFilterWrapper = styled('div')({
    display: 'none',
    [breakpoint('lg')]: {
        display: 'flex',
        flexDirection: 'column',
    },
})

export const SidebarAccordionContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: calcRem(24),
    [breakpoint('lg')]: {
        display: 'none',
    },
})

export const CustomAccordionContentWrapper = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: calcRem(24),
})
